import React from 'react'

const sectorsData = [
   { id: '01', text: 'Hospitals & Clinics' },
   { id: '02', text: 'Pharmaceutical Companies' },
   { id: '03', text: 'Medical Device Manufacturers' },
   { id: '04', text: 'Diagnostic Laboratories' },
   { id: '05', text: 'Healthcare NGOs' },
   { id: '06', text: 'Health Insurance Providers' },
   { id: '07', text: 'Rehabilitation Centers' },
   { id: '08', text: 'Telemedicine Providers' },
   { id: '09', text: 'Long-term Care Facilities' },
   { id: '10', text: 'Mental Health Facilities' },
   { id: '11', text: 'Specialty Care Clinics' },
   { id: '12', text: 'Hospice Care Providers' },
   { id: '13', text: 'Government Health Departments' },
   { id: '14', text: 'HealthTech Startups' },
   { id: '15', text: 'Research Institutions' },
   { id: '16', text: 'Home Healthcare Providers' },
   { id: '17', text: 'Fitness & Wellness Centers' },
   { id: '18', text: 'Biotechnology Firms' },
   { id: '19', text: 'Academic Medical Centers' },
   { id: '20', text: 'Medical Billing Companies' },
   { id: '21', text: 'Population Health Management Organizations' },
   { id: '22', text: 'Clinical Research Organizations (CROs)' },
   { id: '23', text: 'Health Information Exchanges (HIEs)' },
   { id: '24', text: 'Medical Biotech Companies' },
   { id: '25', text: 'Occupational Health & Safety Organizations' },
]

function SectorsWeEmpower() {
   return (
      <section className="section_secondary_bg">
         <div className="container">
            <h2 className="section_heading_title mb-3">
               Sectors We Empower with Our Healthcare Software Solutions
            </h2>
            <p className="info_tell_description cs-text-primary mb-4">
               Benzatine uses effective healthcare software to increase efficiency, improve the level of care given to patients, and consolidate processes. The products we create find application across multiple industries that work to deliver efficient healthcare solutions such as:
            </p>
            <div className="ind-travel-section">
               <div className="ind-travel-wrap">
                  {sectorsData.map(({ id, text }) => (
                     <div key={id} className="ind-travel-icon-content">
                        <div className="ind-travel-icon">
                           <p>{id}</p>
                        </div>
                        <p className="ind-travel-text">{text}</p>
                     </div>
                  ))}
               </div>
            </div>
         </div>
      </section>
   )
}

export default SectorsWeEmpower
